import type { ShippingClient, TypedClient } from '@platform/openapi';
import { useNavigate } from '@tanstack/react-router';
import { SetupWizard } from '../features/setup/SetupWizard.tsx';
import { BrandLockup } from '../shell/BrandLockup.tsx';
import { SessionGate } from '../shell/SessionGate.tsx';
import { useSupportLinks } from '../shell/support.tsx';
import { SETUP_PATH } from '../features/setup/setup-path.ts';
import { DASHBOARD_DEFAULTS } from './search-params.ts';

export type SetupRouteProps = { api: TypedClient; shipping: ShippingClient; step: number };

export const SetupRoute = ({ api, shipping, step }: SetupRouteProps) => {
  const support = useSupportLinks();
  const navigate = useNavigate();
  const toDashboard = () => {
    void navigate({ to: '/', search: DASHBOARD_DEFAULTS });
  };
  return (
    <SessionGate>
      <SetupWizard
        api={api}
        shipping={shipping}
        step={step}
        brand={<BrandLockup surface="plain" />}
        guideUrl={support.mode === 'links' ? support.guidesUrl : null}
        onStep={(next) => {
          void navigate({ to: SETUP_PATH, search: { step: next } });
        }}
        onExit={toDashboard}
        onFinished={toDashboard}
      />
    </SessionGate>
  );
};
